import axios from 'axios';

const url = process.env.REACT_APP_RESTAPI;
const urlV3 = process.env.REACT_APP_RESTAPI_V3;

export const APIUpdateDevice = async (token, agencyId, params) => {
    const result = await axios.patch(`${urlV3}/devices`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error.response.status);
    return result;
};

export const APIUpdateUsers = async (token, agencyId, params) => {
    // console.log('APIUpdateUsers', `${urlV3}/account`, token);
    const result = await axios.patch(`${urlV3}/account`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    // console.log('RESULT: ', result);
    return result;
};

export const APIUpdateTeamMember = async (token, agencyId, params) => {
    const result = await axios.patch(`${urlV3}/team`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APITransferOwnership = async (token, agencyId, params) => {
    const result = await axios.patch(`${urlV3}/transferOwnership`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPatchUpdatePassword = async (params, setLoading) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/updatePassword`, params).catch((error) => error);
    return result;
};

export const APIPatchAgencyDetails = async (token, agencyId, params) => {
    const result = await axios.patch(`${urlV3}/agency`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPatchGeofence = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/geofence`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPatchSIM = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/sims`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPatchAlertPolicy = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/alertPolicy`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPatchAlerts = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/alerts`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIUpdateBatteryPolicy = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/batteryPolicies`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIUpdateFuelPolicy = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/fuelPolicies`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

/** Sets policy status to ARCHIVED (same PATCH contract as update). */
export const APIArchiveFuelPolicy = async (token, setLoading, agencyId, params) => {
    return APIUpdateFuelPolicy(token, setLoading, agencyId, params);
};

// Updates a vehicle type's description, or deactivates/reactivates it via isActive. System
// Administrator only. Vehicle types are never renamed or deleted — see device-service for why.
export const APIUpdateVehicleType = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/vehicleTypes`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIUpdateVehicleAdminPreset = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.patch(`${urlV3}/vehicleAdminPreset`, params, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPutMaintenanceRecord = async (token, setLoading, agencyId, recordId, payload) => {
    setLoading(true);
    const encodedId = encodeURIComponent(recordId);
    const result = await axios.put(`${urlV3}/maintenance/${encodedId}`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    setLoading(false);
    return result;
};

/** HTTP PUT /v3/assets/{assetId}/service-schedule — upsert service schedule config (not PATCH). */
export const APIPutAssetServiceSchedule = async (token, setLoading, agencyId, assetId, payload) => {
    setLoading(true);
    const encodedId = encodeURIComponent(assetId);
    const result = await axios.put(`${urlV3}/assets/${encodedId}/service-schedule`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    setLoading(false);
    return result;
};

/** HTTP PUT /v3/assets/{assetId}/compliance — upsert vehicle compliance (not PATCH). */
export const APIPutAssetCompliance = async (token, setLoading, agencyId, assetId, payload) => {
    setLoading(true);
    const encodedId = encodeURIComponent(assetId);
    const result = await axios.put(`${urlV3}/assets/${encodedId}/compliance`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    setLoading(false);
    return result;
};
